import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useForm } from "react-hook-form";
import { useAdultModeQuery, usePaymentInstrumentInfoQuery, usePurchaseEstimateQuery, usePurchaseEstimateWithCouponLazyQuery } from "@/hooks";
import { useState, useEffect, useMemo, useCallback } from "react";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import { rightViewTerm } from "@/components/RightViewTerm";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import OnlyAndroid from "@/components/OnlyAndroid";
import TargetBlankLink from "@/components/TargetBlankLink";
import { ErrorMessage } from "@/components/Form/Parts/index";
import { Button } from "@/components/Buttons";
import CouponCodeForm from "@/components/Form/CouponCodeForm";
import Loading from "@/components/Loading";
import { PAYMENT_METHOD_ID, PAYMENT_METHOD_NAMES } from "@/lib/constants";
import dayjs from "@/lib/day";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import formStyles from "@/styles/Form.module.scss";
import config from "@/lib/config";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PurchaseFormStep2(_ref) {
  var _estimateWithCoupon$p, _estimateWithCoupon$p2;

  var onSubmit = _ref.onSubmit,
      product = _ref.product,
      broadcastDiscount = _ref.broadcastDiscount,
      paymentMethodId = _ref.paymentMethodId,
      paymentInstrumentId = _ref.paymentInstrumentId,
      error = _ref.error,
      onBack = _ref.onBack,
      setSubmitted = _ref.setSubmitted;
  var router = useRouter();

  var _useState = useState(),
      unappliedCouponError = _useState[0],
      setUnppliedCouponError = _useState[1];

  var _useState2 = useState(),
      applyVoucherCode = _useState2[0],
      setApplyVoucherCode = _useState2[1]; // 視聴期間


  var _rightViewTerm = rightViewTerm(product === null || product === void 0 ? void 0 : product.right),
      _rightViewTerm2 = _slicedToArray(_rightViewTerm, 2),
      rightLabel = _rightViewTerm2[0],
      rightText = _rightViewTerm2[1]; // 決済日


  var purchaseDate = dayjs().format("YYYY/MM/DD"); // 販売期間

  var salesStartAt = product !== null && product !== void 0 && product.sales_start_at ? dayjs(product.sales_start_at).format("YYYY/MM/DD") : null;
  var salesEndAt = product !== null && product !== void 0 && product.sales_end_at ? dayjs(product.sales_end_at).format("YYYY/MM/DD") : null; // react-hook-form

  var _useForm = useForm({
    mode: "all"
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      getValues = _useForm.getValues,
      setValue = _useForm.setValue,
      watch = _useForm.watch;

  var isValid = formState.isValid,
      isSubmitting = formState.isSubmitting;
  var watchCouponCode = watch("couponCode"); // Graphql

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultModeData = _useAdultModeQuery.data;

  var adultMode = adultModeData === null || adultModeData === void 0 ? void 0 : adultModeData.adultMode; // 支払い方法

  var _usePaymentInstrument = usePaymentInstrumentInfoQuery({
    variables: {
      id: paymentInstrumentId
    }
  }),
      data = _usePaymentInstrument.data,
      loading = _usePaymentInstrument.loading;

  var paymentInstrument = (data === null || data === void 0 ? void 0 : data.paymentInstrumentInfo) || {};
  var paymentMethod = useMemo(function () {
    if (paymentInstrument) {
      return paymentInstrument.payment_method_id;
    }
  }, [paymentInstrument]);
  var paymentIconClassName = useMemo(function () {
    return paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD ? styles.paymentCreditCardImage : styles.paymentOtherImage;
  }, [paymentMethod]);
  var creditCardInfo = useMemo(function () {
    if (paymentInstrument) {
      var _paymentInstrument$va, _paymentInstrument$va2;

      return {
        type: paymentInstrument === null || paymentInstrument === void 0 ? void 0 : (_paymentInstrument$va = paymentInstrument.values) === null || _paymentInstrument$va === void 0 ? void 0 : _paymentInstrument$va.card_type,
        number: "****-****-****-".concat(paymentInstrument === null || paymentInstrument === void 0 ? void 0 : (_paymentInstrument$va2 = paymentInstrument.values) === null || _paymentInstrument$va2 === void 0 ? void 0 : _paymentInstrument$va2.card_number)
      };
    }
  }, [paymentInstrument]); // 購入可能か確認

  var _usePurchaseEstimateQ = usePurchaseEstimateQuery({
    variables: {
      productId: Number(product.id),
      paymentMethodId: paymentMethodId
    },
    onCompleted: function onCompleted(_ref2) {
      var estimate = _ref2.estimate;

      // エラーの場合は前のページに戻す
      if (estimate !== null && estimate !== void 0 && estimate.error) {
        onBack(estimate.error);
      }
    }
  }),
      estimateData = _usePurchaseEstimateQ.data,
      estimateLoading = _usePurchaseEstimateQ.loading;

  var estimate = estimateData === null || estimateData === void 0 ? void 0 : estimateData.estimate; // クーポン

  var _usePurchaseEstimateW = usePurchaseEstimateWithCouponLazyQuery({
    variables: {
      productId: Number(product.id),
      paymentMethodId: paymentMethodId
    },
    onCompleted: function onCompleted(_ref3) {
      var estimateWithCoupon = _ref3.estimateWithCoupon;

      var voucherCode = function () {
        if (!(estimateWithCoupon !== null && estimateWithCoupon !== void 0 && estimateWithCoupon.error)) {
          return getValues("couponCode");
        }

        return null;
      }();

      setApplyVoucherCode(voucherCode);
      setValue("couponCode", "", {
        shouldValidate: true
      });
    }
  }),
      _usePurchaseEstimateW2 = _slicedToArray(_usePurchaseEstimateW, 2),
      estimateWithCouponQuery = _usePurchaseEstimateW2[0],
      _usePurchaseEstimateW3 = _usePurchaseEstimateW2[1],
      estimateWithCouponData = _usePurchaseEstimateW3.data,
      couponLoading = _usePurchaseEstimateW3.loading;

  var estimateWithCoupon = estimateWithCouponData === null || estimateWithCouponData === void 0 ? void 0 : estimateWithCouponData.estimateWithCoupon;
  var applyVoucher = estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : (_estimateWithCoupon$p = estimateWithCoupon.product) === null || _estimateWithCoupon$p === void 0 ? void 0 : (_estimateWithCoupon$p2 = _estimateWithCoupon$p.voucherCode) === null || _estimateWithCoupon$p2 === void 0 ? void 0 : _estimateWithCoupon$p2.voucher; // 割引価格

  var discountPrice = useMemo(function () {
    // サーバー側で放送契約割引とキャンペーンの割引額を比較しているので
    // バウチャーが適用されたということは放送契約割引より安いということになる
    if (applyVoucher) {
      var _estimateWithCoupon$p3;

      return estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : (_estimateWithCoupon$p3 = estimateWithCoupon.product) === null || _estimateWithCoupon$p3 === void 0 ? void 0 : _estimateWithCoupon$p3.discountPrice;
    }

    if (broadcastDiscount !== null && broadcastDiscount !== void 0 && broadcastDiscount.result) {
      var _product$right;

      return (product === null || product === void 0 ? void 0 : (_product$right = product.right) === null || _product$right === void 0 ? void 0 : _product$right.discount_price) || 0;
    }

    return null;
  }, [product, broadcastDiscount, applyVoucher, estimateWithCoupon]); // 割引の名前

  var discountName = useMemo(function () {
    if (applyVoucher) {
      return applyVoucher.name;
    } else {
      return "放送契約者割引";
    }
  }, [applyVoucher]); // submitのコールバック

  var beforeSubmit = useCallback(function (data) {
    if (data.couponCode) {
      setUnppliedCouponError("クーポンコード入力されていますが適用されていません。\n適用ボタンを押すか、入力をクリアしてから購入するボタンを押してください。");
    } else {
      onSubmit(_objectSpread(_objectSpread({}, data), {
        applyVoucherCode: applyVoucherCode
      }));
    }
  }, [onSubmit, applyVoucherCode]); // 前のページに戻る

  var handleBack = useCallback(function () {
    if (onBack) {
      onBack();
    }
  }, [onBack]); // クーポン適用

  var applyCoupon = useCallback(function () {
    var couponCode = getValues("couponCode");
    estimateWithCouponQuery({
      variables: {
        voucherCode: couponCode,
        userVoucherId: broadcastDiscount === null || broadcastDiscount === void 0 ? void 0 : broadcastDiscount.user_voucher_id
      }
    });
  }, [broadcastDiscount]); // クーポンの適用キャンセル

  var handleCouponCancel = useCallback(function () {
    estimateWithCouponQuery({
      variables: {
        couponCode: null
      }
    });
  }, []); // クーポンコードのフォームが空になったら購入ボタン上のエラーメッセージをリセット

  useEffect(function () {
    if (unappliedCouponError && !watchCouponCode) {
      setUnppliedCouponError("");
    }
  }, [unappliedCouponError, watchCouponCode]); // ページ遷移したら購入ボタンを有効にする

  useEffect(function () {
    var resetSubmitted = function resetSubmitted() {
      setSubmitted(false);
    };

    router.events.on("routeChangeComplete", resetSubmitted);
    return function () {
      router.events.off("routeChangeComplete", resetSubmitted);
    };
  }, []);
  if (loading || estimateLoading) return null;
  if (!(estimate !== null && estimate !== void 0 && estimate.product)) return null; // 放送契約割引がある
  // 視聴期間も表示する

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [couponLoading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), adultMode && /*#__PURE__*/_jsx(OnlyAndroid, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.cautionSection,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.text,
          children: /*#__PURE__*/_jsxs("p", {
            children: ["\u5546\u54C1\u3092\u8CFC\u5165\u3059\u308B\u969B\u306B\u306F\u3001\u5FC5\u305A", /*#__PURE__*/_jsx(TargetBlankLink, {
              href: routes.environment,
              className: styles.link,
              children: "\u52D5\u4F5C\u74B0\u5883"
            }), "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u307E\u305F\u3001", /*#__PURE__*/_jsx(TargetBlankLink, {
              href: routes.watch(config.adultViewingConfirmationProgramId),
              className: styles.link,
              children: "\u8996\u8074\u78BA\u8A8D\u756A\u7D44"
            }), "\u3067\u306E\u8996\u8074\u78BA\u8A8D\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"]
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(processStyles.content, " ").concat(styles.container),
        children: [/*#__PURE__*/_jsx("p", {
          className: processStyles.contentHeader,
          children: "\u4E0B\u8A18\u306E\u5185\u5BB9\u3067\u8CFC\u5165\u3057\u307E\u3059\u304B\uFF1F"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.container,
          children: /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.section, " ").concat(styles.column),
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u5546\u54C1\u540D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: product.name
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u91D1\u984D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: /*#__PURE__*/_jsxs("span", {
                    className: styles.priceAmount,
                    children: [formatPrice(product.price), "\u5186", /*#__PURE__*/_jsx("span", {
                      children: "\uFF08\u7A0E\u8FBC\uFF09"
                    })]
                  })
                })]
              }), discountPrice && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.label,
                    children: "\u9069\u7528\u3055\u308C\u308B\u5272\u5F15"
                  }), /*#__PURE__*/_jsxs("div", {
                    className: styles.value,
                    children: [discountName, applyVoucher && /*#__PURE__*/_jsx("a", {
                      className: "".concat(styles.couponCancelLink, " ").concat(styles.inline),
                      onClick: handleCouponCancel,
                      children: "\u9069\u7528\u3092\u89E3\u9664\u3059\u308B"
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.label,
                    children: "\u5272\u5F15\u9069\u7528\u5F8C\u4FA1\u683C"
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.value,
                    children: /*#__PURE__*/_jsxs("span", {
                      className: styles.priceAmount,
                      children: [formatPrice(discountPrice), "\u5186", /*#__PURE__*/_jsx("span", {
                        children: "\uFF08\u7A0E\u8FBC\uFF09"
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u652F\u6255\u65B9\u6CD5"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [/*#__PURE__*/_jsx("div", {
                    children: PAYMENT_METHOD_NAMES[paymentMethod]
                  }), paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD && /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx(PaymentIconImage, {
                      paymentMethodId: paymentMethod,
                      cardType: creditCardInfo.type,
                      className: paymentIconClassName
                    }), /*#__PURE__*/_jsx("span", {
                      children: creditCardInfo.number
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u6C7A\u6E08\u65E5"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: purchaseDate
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u8CA9\u58F2\u671F\u9593"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [salesStartAt, " \u301C ", salesEndAt]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: rightLabel
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: rightText
                })]
              })]
            })
          })
        })]
      })
    }), error && /*#__PURE__*/_jsx("div", {
      className: styles.creditCardError,
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        msg: error
      })
    }), /*#__PURE__*/_jsx(CouponCodeForm, {
      enable: !applyVoucherCode,
      register: register,
      apply: applyCoupon,
      error: estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : estimateWithCoupon.error
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.guideArea,
      children: /*#__PURE__*/_jsxs("p", {
        children: ["\u89E3\u7D04\u306B\u3064\u3044\u3066", /*#__PURE__*/_jsx("br", {}), "\u5546\u54C1\u306E\u6027\u8CEA\u4E0A\u3001\u6C7A\u6E08\u5B8C\u4E86\u5F8C\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3084\u8FD4\u91D1\u7B49\u306B\u306F\u5FDC\u3058\u3089\u308C\u307E\u305B\u3093\u3002"]
      })
    }), /*#__PURE__*/_jsx("form", {
      onSubmit: handleSubmit(beforeSubmit),
      noValidate: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: formStyles.btnArea,
        children: [/*#__PURE__*/_jsx(Button, {
          type: "submit",
          fillColor: true,
          fontFixed: true,
          large: true,
          disabled: !isValid,
          loading: isSubmitting,
          children: "\u8CFC\u5165\u3059\u308B"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.backButton,
          children: /*#__PURE__*/_jsx("a", {
            onClick: handleBack,
            children: "\u524D\u306E\u753B\u9762\u3078\u623B\u308B"
          })
        })]
      })
    })]
  });
}